'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardDepartmentCtrl', ['departments', '$scope','$state','formsPreview','tasksPreview', require('./dashboardDepartmentCtrl')]);
app.directive('tasksPreview', [require('./tasksPreviewDirective')]);
app.config(['$stateProvider', require('./dashboardDepartmentConfig')]);
